var React = require('react');

function SmokingBan (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm10,12c0,2.398-.85,4.6-2.262,6.324l-2.324-2.324h.586c.552,0,1-.447,1-1v-2c0-.553-.448-1-1-1h-4.586l-7.738-7.738c1.725-1.412,3.927-2.262,6.324-2.262,5.514,0,10,4.486,10,10Zm-20,0c0-2.398.85-4.6,2.262-6.324l14.062,14.062c-1.725,1.412-3.927,2.262-6.324,2.262-5.514,0-10-4.486-10-10Zm9-7c0-.553.448-1,1-1s1,.447,1,1c0,.1.262.464,1.064.692l2.422.691c1.551.443,2.514,1.446,2.514,2.616,0,.553-.448,1-1,1s-1-.447-1-1c0-.1-.262-.464-1.063-.692l-2.422-.691c-1.551-.443-2.515-1.446-2.515-2.616Zm-3.242,7l4,4h-5.758c-.552,0-1-.448-1-1v-2c0-.552.448-1,1-1h1.758Z"}));
}

SmokingBan.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 24 24","fill":"#ffffff"};

module.exports = SmokingBan;

SmokingBan.default = SmokingBan;
